export const SSO_SESSION_EXPIRED = "SSO_SESSION_EXPIRED";
export const SSO_SESSION_RESET = "SSO_SESSION_RESET";

const initialState = {
  isExpired: false,
  userEmail: "",
};

export default function ssoSessionExpired(state = initialState, action) {
  switch (action.type) {
    case SSO_SESSION_EXPIRED:
      return { isExpired: true, userEmail: action.payload.userEmail };
    case SSO_SESSION_RESET:
      return initialState;
    default:
      return state;
  }
}
